import * as types from "../Actions/ActionTypes";

//초기 상태 설정

const initialState = {
  text: {
    target: "",
    opinion: "",
    reason: "",
    example: "",
    offer: "",
    sum: ""
  }
};

export default function reducer(state = initialState, action) {
  // console.log(action);
  const title = action.title;
  if (action.type === types.WRITE) {
    return {
      text: {
        ...state.text,
        [title]: action.content
      }
    };
  } else if (action.type === types.CLEAR) {
    return {
      text: {
        target: "",
        opinion: "",
        reason: "",
        example: "",
        offer: "",
        sum: ""
      }
    };
  } else {
    return state;
  }
}
